import { render, staticRenderFns } from "./BaAdminBidWanted.vue?vue&type=template&id=7af69168&scoped=true&"
import script from "./BaAdminBidWanted.vue?vue&type=script&lang=js&"
export * from "./BaAdminBidWanted.vue?vue&type=script&lang=js&"
import style0 from "./BaAdminBidWanted.vue?vue&type=style&index=0&id=7af69168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af69168",
  null
  
)

export default component.exports